import React from "react";
import { Link } from "react-router-dom";
import RegisterForm from "../components/RegisterForm";
import { AuthLayout } from "../components/auth/AuthLayout";

export default function RegisterPage() {
  return (
    <AuthLayout
      title="Crea tu espacio financiero"
      subtitle="Importa movimientos, categoriza gastos y comparte la visión económica con tu familia."
      footer={
        <p className="section-subtitle">
          ¿Ya tienes cuenta? <Link to="/auth/login">Inicia sesión aquí</Link>
        </p>
      }
    >
      <RegisterForm />
    </AuthLayout>
  );
}
